import Input from '#components/general/Input';
import { getSubStepValues } from '#models/general/steps';
import { mapPeriodsOptions } from '#models/periods';
import { getSelectField } from '#utils/select';

import { SPIRIT_REDUCTIONS_SUBSTEPS_IDS, SPIRIT_REDUCTION_INITIAL_PAGE_FIELDS } from './constants';

export const getInitialPageFields = ({ values, errors, periods }) => {
  const getInitialPageValues = getSubStepValues(SPIRIT_REDUCTIONS_SUBSTEPS_IDS.INITIAL_PAGE, values, errors);
  return [
    getSelectField({
      field: SPIRIT_REDUCTION_INITIAL_PAGE_FIELDS.PERIOD_ID,
      values,
      options: mapPeriodsOptions(periods),
      customOptions: true,
      getValues: getInitialPageValues
    }),
    {
      ...getInitialPageValues(SPIRIT_REDUCTION_INITIAL_PAGE_FIELDS.FILL_ID),
      Component: Input,
      noMargin: true
    },
    {
      ...getInitialPageValues(SPIRIT_REDUCTION_INITIAL_PAGE_FIELDS.DATE),
      Component: Input,
      type: 'date',
      noMargin: true
    },
    {
      ...getInitialPageValues(SPIRIT_REDUCTION_INITIAL_PAGE_FIELDS.OPERATOR),
      Component: Input,
      noMargin: true
    }
  ];
};
